import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { PetService } from '../../../services/pet.service';
import { ClientService } from '../../../services/client.service';
import { SetupService } from '../../../services/setup.service';
import { PetNoteModel } from '../../../models/pet-note.model';
import { ProcedureService } from '../../../services/procedure.service';
import { SetupDrugLabelModel } from '../../../models/setup-drug-label.model';
import Swal from 'sweetalert2';
import { ITreeOptions, TreeModel, TreeNode } from '@circlon/angular-tree-component';
import { HistoryModel, PrescriptionsModel } from '../../../models/history.model';
import * as _ from 'lodash';
import { PetProcsModel } from '../../../models/pet-proc.model';

declare var $: any;

// Utility functions for encoding
function encode_utf8(s: string): string {
  return unescape(encodeURIComponent(s));
}

function encode_base64(s: string): string {
  return btoa(s);
}

@Component({
  selector: 'ngx-landing-page',
  templateUrl: './landing-page.component.html',
  styles: [`
    .table-active {
      background-color: #e3f2fd !important;
      color: inherit !important;
    }
    .table-active:hover {
      background-color: #bbdefb !important;
    }
    .table-active td {
      color: inherit !important;
    }
  `]
})
export class LandingPageComponent implements OnInit {

  private _pet_no: number;
  private _client_no: number;
  procedures = true;
  estimate = false;
  prescriptions = false;
  info = false;
  vitalsign = false;
  physical = false;
  parameters = false;
  treatments = false;
  notes = false;
  recalls = false;
  check_in = false;
  metrics = false;
  show_detail = false;
  appt_referred = false;
  appt_referred_loaded = false;
  estimate_loaded = false;
  prescriptions_loaded = false;
  info_loaded = false;
  physical_loaded = false;
  treatments_loaded = false;
  notes_loaded = false;
  recalls_loaded = false;
  check_in_loaded = false;
  metrics_loaded = false;
  vitalsign_loaded = false;
  selectedTreeList = [];
  selectedTreeList1 = [];
  selectedTreeList2 = [];
  selectedTreeList3 = [];
  id_filter = 0;
  code = '';
  category = '';
  subcategory = '';
  filtering = false;
  filtering_presc = false;
  description = '';
  selectedPrescription: PrescriptionsModel | null = null;

  // Print modal properties
  printOptions = {
    printType: '',
    beginDate: '',
    endDate: '',
    printPrescriptionLog: false
  };

  @Input() set pet_no(value: number) {
    this._pet_no = value;
  }

  get pet_no(): number {
    return this._pet_no;
  }

  @Input() set client_no(value: number) {
    this._client_no = value;
  }

  get client_no(): number {
    return this._client_no;
  }

  constructor(
    public petService: PetService,
    public clientService: ClientService,
    private route: ActivatedRoute,
    private setupService: SetupService,
    public procedureService: ProcedureService
  ) {
  }

  ngOnInit() {
    // Load clinic details for prescription reports
    this.loadClinicDetails();

    this.petService.changePet
      .subscribe(message => {
        if (message !== this.pet_no) {
          console.log('Pet changed from', this.pet_no, 'to', message);
          this.pet_no = message;
          //this.petService.getNotesByPetId(this.pet_no).then(() => { });
          this.client_no = this.clientService.current_client_no;

          // Load prescriptions data if prescriptions tab is active
          if (this.prescriptions && this.pet_no > 0) {
            console.log('Loading prescriptions data on pet change');
            this.loadPrescriptionsData();
          }

          this.ver('procedures');

          // Re-render metrics charts when pet changes while metrics tab is active
          if (this.metrics) {
            this.petService.view_physical = true;
          }
        }
      });

    console.log('Landing Page RUN - Initial pet_no:', this.pet_no);

    // Load initial data if pet_no is already set
    if (this.pet_no > 0) {
      console.log('Loading initial prescriptions data');
      this.loadPrescriptionsData();
    }
  }

  private loadClinicDetails() {
    // Get current user's clinic number and load clinic details
    if (localStorage.currentUser && localStorage.token) {
      const currentUser = JSON.parse(localStorage.currentUser);
      const clinicNo = currentUser.clinic_no;

      if (clinicNo) {
        this.clientService.GetClinicDetailsByNo(clinicNo).then(() => {
          console.log('Clinic details loaded:', this.clientService.clinic_details);
        }).catch(error => {
          console.error('Error loading clinic details:', error);
        });
      }
    }
  }

  onlyUnique(value, index, array) {
    return array.indexOf(value) === index;
  }

  clear(treeModel: TreeModel, close: boolean = false) {
    this.filtering = false;
    this.filtering_presc = false;
    this.petService.pet_histories_filter = [];
    this.petService.pet_prescriptions_filter = [];
    this.selectedTreeList = [];

    treeModel.getActiveNodes().forEach((element: TreeNode) => {
      element.setIsActive(false);
    });


    if (close)
      $('#modalFilterHistory').modal('toggle');

  }

  ver(tipo: string) {
    console.log('Switching to tab:', tipo, 'pet_no:', this.pet_no);

    this.procedures = tipo === 'procedures'
    this.estimate = tipo === 'estimate'
    this.prescriptions = tipo === 'prescriptions'
    this.info = tipo === 'info'
    this.physical = tipo === 'physical'
    this.treatments = tipo === 'treatments'
    this.vitalsign = tipo === 'vitalsign'
    this.notes = tipo === 'notes'
    this.recalls = tipo === 'recalls'
    this.check_in = tipo === 'check_in'
    this.metrics = tipo === 'metrics'
    this.appt_referred = tipo === 'appt_referred'
    // Trigger chart render on metrics tab
    this.petService.view_physical = tipo === 'metrics';
    this.estimate_loaded = this.estimate_loaded || tipo === 'estimate';
    this.prescriptions_loaded = this.prescriptions_loaded || tipo === 'prescriptions';
    this.info_loaded = this.info_loaded || tipo === 'info';
    this.physical_loaded = this.physical_loaded || tipo === 'physical';
    this.treatments_loaded = this.treatments_loaded || tipo === 'treatments';
    this.notes_loaded = this.notes_loaded || tipo === 'notes';
    this.recalls_loaded = this.recalls_loaded || tipo === 'recalls';
    this.check_in_loaded = this.check_in_loaded || tipo === 'check_in';
    this.metrics_loaded = this.metrics_loaded || tipo === 'metrics';
    this.vitalsign_loaded = this.vitalsign_loaded || tipo === 'vitalsign';
    this.appt_referred_loaded = this.appt_referred_loaded || tipo === 'appt_referred';

    // Clear prescription selection when switching tabs
    this.selectedPrescription = null;

    // Load prescriptions data when prescriptions tab is activated
    if (tipo === 'prescriptions' && this.pet_no > 0) {
      console.log('Loading prescriptions data for tab switch');
      this.loadPrescriptionsData();
    }

    // Load history data when history tab is activated
    if (tipo === 'info' && this.pet_no > 0) {
      this.petService.pet_histories = [];
      this.petService.pet_subhistories = [];
      this.petService.pet_suggestions = [];
      this.petService.pet_prescriptions = [];
      this.petService.histories_page_number = 1;
      this.loadHistoryData();
    }
  }

  chgCategory() {
    if (String(this.category) === '') {
      this.selectedTreeList3 = [];
      return;
    }

    let arr = [];
    this.petService.pet_histories.forEach(element => {
      if (element.category_name === this.category && element.subcategory_name)
        arr.push(element.subcategory_name);
    });

    var unique = arr.filter(this.onlyUnique);
    this.selectedTreeList3 = unique.sort((a, b) => (a < b) ? -1 : 1);
  }

  loadHistoryData() {
    // Set the current pet number in the service before making the API call
    Swal.fire({
      title: 'Loading...',
      timerProgressBar: true,
      didOpen: () => {
        Swal.showLoading()
      },
    })
    this.petService.current_pet_no = this.pet_no;

    // Load history data by calling getHistoriesByPetId
    this.petService.getHistoriesByPetId(this.pet_no)
      .then(() => {
        console.log('History data loaded:', this.petService.pet_histories);
        Swal.close();
      })
      .catch((error) => {
        console.error('Error loading history data:', error);
      });
  }

  selectPresc(item: PrescriptionsModel) {
    this.selectedPrescription = item;
  }

  selected(treeModel: TreeModel) {
    this.selectedTreeList = [];

    treeModel.getActiveNodes().forEach(element => {
      this.selectedTreeList.push(element.data.id);
    });
  }

  apply(treeModel) {
    this.selected(treeModel);

    if (this.id_filter === 1) {
      // Filter for History
      if (this.selectedTreeList && this.selectedTreeList.length > 0) {
        this.filtering = true;
        let by_code = []
        by_code.push(..._.filter(this.petService.pet_histories, (row: HistoryModel) => this.selectedTreeList.some(t => t === row.procedure_desc)
          && row.code_name === (this.code !== '' ? this.code : row.code_name) && row.category_name === (this.category !== '' ? this.category : row.category_name)
          && row.subcategory_name === (this.subcategory !== '' ? this.subcategory : row.subcategory_name)
          && row.procedure_desc.toLowerCase().includes(this.description !== '' ? this.description.toLowerCase() : row.procedure_desc.toLowerCase())));
        by_code.sort((a, b) => (this.parseToTime1(a.done_date) < this.parseToTime1(b.done_date)) ? -1 : 1);
        this.petService.pet_histories_filter = []
        this.petService.pet_histories_filter.push(...by_code)
      } else {
        // Search by description only or other filters
        if (this.description !== '' || this.code !== '' || this.category !== '' || this.subcategory !== '') {
          this.filtering = true;
          let by_code = []
          by_code.push(..._.filter(this.petService.pet_histories, (row: HistoryModel) =>
            row.code_name === (this.code !== '' ? this.code : row.code_name)
            && row.category_name === (this.category !== '' ? this.category : row.category_name)
            && row.subcategory_name === (this.subcategory !== '' ? this.subcategory : row.subcategory_name)
            && row.procedure_desc.toLowerCase().includes(this.description !== '' ? this.description.toLowerCase() : row.procedure_desc.toLowerCase())
          ));
          by_code.sort((a, b) => (this.parseToTime1(a.done_date) < this.parseToTime1(b.done_date)) ? -1 : 1);
          this.petService.pet_histories_filter = []
          this.petService.pet_histories_filter.push(...by_code)
        }
      }

    } else if (this.id_filter === 3) {
      // Filter for Prescriptions
      if (this.selectedTreeList && this.selectedTreeList.length > 0) {
        this.filtering_presc = true;
        let by_code = []
        by_code.push(..._.filter(this.petService.pet_prescriptions, (row: PrescriptionsModel) => this.selectedTreeList.some(t => t === row.product_name)
          && row.instructions.toLowerCase().includes(this.description !== '' ? this.description.toLowerCase() : row.instructions.toLowerCase())));
        by_code.sort((a, b) => (this.parseToTime1(a.drug_note_date) < this.parseToTime1(b.drug_note_date)) ? -1 : 1);
        this.petService.pet_prescriptions_filter = []
        this.petService.pet_prescriptions_filter.push(...by_code)
      } else {
        // Search by instructions only or other filters
        if (this.description !== '') {
          this.filtering_presc = true;
          let by_code = []
          by_code.push(..._.filter(this.petService.pet_prescriptions, (row: PrescriptionsModel) =>
            row.instructions.toLowerCase().includes(this.description !== '' ? this.description.toLowerCase() : row.instructions.toLowerCase())));
          by_code.sort((a, b) => (this.parseToTime1(a.drug_note_date) < this.parseToTime1(b.drug_note_date)) ? -1 : 1);
          this.petService.pet_prescriptions_filter = []
          this.petService.pet_prescriptions_filter.push(...by_code)
        }
      }

    }


    $('#modalFilterHistory').modal('toggle');

  }

  parseToTime1(date: string) {
    let split = date.split('/');
    if (split) {
      let date = new Date(Number(split[2]), Number(split[0]) - 1, Number(split[1]));
      return date.getTime()
    }
    return 0;
  }

  onScroll() {
    this.petService.getHistoriesByPetId(this.petService.current_pet_no)
      .then(() => {
      });
  }

  async updatePresc(item: PrescriptionsModel) {
    //debugger;
    console.log(item);
    let intCodeNo = 0;
    let strDate = '';
    let strTemp = '';
    let intRefill = 0;
    let strNext = '';

    this.selectedPrescription = item;

    if (item.in_clinic === 'False') {
      Swal.fire({
        title: 'Create another written Rx for this product?',
        showCancelButton: true,
        cancelButtonText: 'No',
        confirmButtonText: 'Yes'
      }).then(async (result: any) => {
        if (result.isConfirmed) {
          await this.writtenRx(item);
        }
      });
      return;
    }

    debugger;
    await this.setupService.getInventInfo('', item.product_name, 1)
      .then(() => {
        if (this.setupService.invent_info.item_no === '') {
          intCodeNo = Number(this.setupService.invent_info.item_no);
        } else {
          Swal.fire('No item found with this description. Item description may have changed in the database. Please create a new prescription to generate refills.');
          return;
        }
      });

    let lngSeq = Number(item.drug_note_sequence);
    let strDoctor = item.employee_initial;

    // Calculate default refill expiry date
    var refill_expire = '';
    let today_refill = new Date();
    today_refill.setFullYear(today_refill.getFullYear() + 1);
    if (today_refill) {
      var split = today_refill.toLocaleDateString("en-US").split('/');
      refill_expire = `${split[2]}-${split[0].padStart(2, '0')}-${split[1].padStart(2, '0')}`;
    }

    // Single dialog with all 4 questions
    const { value: formValues } = await Swal.fire({
      title: 'Update Prescription',
      customClass: {
        popup: 'swal-wide-popup'
      },
      html: `
        <div style="text-align: left; margin-bottom: 2px;">
          <label style="display: inline-block; min-width: 200px; margin-right: 1px;">- Enter initials of doctor approving refills:</label>
          <input id="swal-input1" class="swal1-input" value="${strDoctor}" placeholder="Enter doctor initials">
        </div>
        <div style="text-align: left; margin-bottom: 2px; display: inline-block;" >
          <label style="display: inline-block; min-width: 200px; margin-right: 1px;">- Please enter number of refills allowed for ${item.product_name}.</label>
          <label style="display: inline-block; min-width: 200px; margin-right: 1px;">&nbsp;&nbsp;&nbsp;Use 'PRN' for unlimited refills:</label>
          <input id="swal-input2" class="swal1-input" value="${item.refill_count}" placeholder="Enter number or 'PRN'">
        </div>
        <div style="text-align: left; margin-bottom: 2px;">
          <label style="display: inline-block; min-width: 200px; margin-right: 1px;">- Please enter refill expiry date:</label>
          <input id="swal-input3" class="swal2-input" type="date" value="${refill_expire}">
        </div>
        <div style="text-align: left; margin-bottom: 2px;">
          <label style="display: inline-block; min-width: 200px; margin-right: 1px;">- Enter date of next allowed refill:</label>
          <input id="swal-input4" class="swal2-input" type="date" value="${refill_expire}">
        </div>
      `,
      focusConfirm: false,
      showCancelButton: true,
      cancelButtonText: 'Cancel',
      confirmButtonText: 'OK',
      preConfirm: () => {
        const doctorInitials = (document.getElementById('swal-input1') as HTMLInputElement).value;
        const refillCount = (document.getElementById('swal-input2') as HTMLInputElement).value;
        const refillExpiry = (document.getElementById('swal-input3') as HTMLInputElement).value;
        const nextRefillDate = (document.getElementById('swal-input4') as HTMLInputElement).value;

        if (!doctorInitials || !refillCount || !refillExpiry || !nextRefillDate) {
          Swal.showValidationMessage('Please fill in all fields');
          return false;
        }

        return {
          doctorInitials,
          refillCount,
          refillExpiry,
          nextRefillDate
        };
      }
    });

    if (formValues) {
      strDoctor = formValues.doctorInitials;
      strDate = formValues.refillCount;
      strNext = formValues.nextRefillDate;

      if (strDate === 'PRN') {
        intRefill = -1;
      } else if (strDate === '') {
        return;
      } else {
        intRefill = Number(strDate);
      }

      if (intRefill < -1) {
        Swal.fire('Number of refills must be greater than or equal to zero.');
        return;
      }

      const refillExpiryDate = formValues.refillExpiry;

      // Update drug note
      this.setupService.setup_druglabel = new SetupDrugLabelModel(lngSeq, intRefill, refillExpiryDate, refillExpiryDate, 0, 0, 1);
      await this.setupService.setupDrugNote()
        .then(() => {
          // Update the next refill date in the drug label
          this.setupService.setup_druglabel = new SetupDrugLabelModel(lngSeq, intRefill, refillExpiryDate, strNext, intCodeNo, this.pet_no, 1);
          return this.setupService.setupDrugLabel();
        });

      // Update prescription data
      if (intRefill === -1) {
        item.refill_count = "PRN";
      } else {
        item.refill_count = `${intRefill}`;
      }
      item.refill_expire = refillExpiryDate;

      // Create note
      strTemp += `For ${item.product_name}, ${strDoctor}  approved `;
      if (intRefill === -1) {
        strTemp += `PRN refills`
      } else if (intRefill === 1) {
        strTemp += `1 refill`
      } else {
        strTemp += `${intRefill} refills`
      }

      strTemp += ` until ${refillExpiryDate}.     -- ${'tdm'}`;

      Swal.fire({
        title: 'Loading...',
        timerProgressBar: true,
        didOpen: () => {
          Swal.showLoading()
        },
      })

      this.petService.pet_note = new PetNoteModel(0, '', this.pet_no, 0, strTemp, '', '');
      var note_sequence = 0;

      this.petService.setupPetNoteByType()
        .then((_note_sequence: number) => {
          note_sequence = _note_sequence;
          let promises = [];
          promises.push(this.petService.setupPetNoteType(new PetNoteModel(note_sequence, '', 0, 2, '', '', '')));
          promises.push(this.petService.setupPetNoteType(new PetNoteModel(note_sequence, '', 0, 25, '', '', '')));

          Promise.all(promises)
            .then(() => {
              this.petService.histories_page_number = 1;
              this.petService.getHistoriesByPetId(this.petService.current_pet_no)
                .then(() => {
                  Swal.fire({
                    title: 'Your information has been saved.',
                    didOpen: () => {
                    },
                  })
                });
            });
        });
    }
  }

  async writtenRx(item: PrescriptionsModel) {
    // Implement written Rx logic here
    console.log('Written Rx for:', item);
  }

  filter(id: number, treeModel: TreeModel) {
    Swal.fire({
      title: 'Loading...',
      timerProgressBar: true,
      didOpen: () => {
        Swal.showLoading()
      },
    })

    let arr = [];
    let arr1 = [];
    let arr2 = [];

    if (this.id_filter !== id) {
      this.nodes = [
        {
          name: '',
          children: []
        }
      ];
      treeModel.nodes[0].children = [];
      this.selectedTreeList = [];
      this.selectedTreeList1 = [];
      this.selectedTreeList2 = [];
      treeModel.update();
      this.id_filter = id;
    }
    this.id_filter = id;
    this.clear(treeModel);

    setTimeout(() => {
      switch (id) {
        case 1:
          if (treeModel.nodes[0].children.length > 0) break;

          this.petService.pet_histories.forEach(element => {
            if (element.procedure_desc)
              arr.push(element.procedure_desc);
            if (element.code_name)
              arr1.push(element.code_name);
            if (element.category_name)
              arr2.push(element.category_name);
          });

          var unique = arr.filter(this.onlyUnique);
          var unique1 = arr1.filter(this.onlyUnique);
          var unique2 = arr2.filter(this.onlyUnique);

          unique.sort((a, b) => (a < b) ? -1 : 1).forEach(element => {
            treeModel.nodes[0].children.push({ id: element, name: element });
          });

          this.selectedTreeList1 = unique1.sort((a, b) => (a < b) ? -1 : 1);
          this.selectedTreeList2 = unique2.sort((a, b) => (a < b) ? -1 : 1);

          treeModel.nodes[0].name = 'Procedures'
          treeModel.update();

          this.petService.pet_histories_filter = [];
          this.petService.pet_histories_filter.push(...this.petService.pet_histories);
          break;

        case 3:
          if (treeModel.nodes[0].children.length > 0) break;

          this.petService.pet_prescriptions.forEach(element => {
            if (element.product_name)
              arr.push(element.product_name);
          });

          var unique = arr.filter(this.onlyUnique);

          unique.sort((a, b) => (a < b) ? -1 : 1).forEach(element => {
            treeModel.nodes[0].children.push({ id: element, name: element });
          });

          treeModel.nodes[0].name = 'Prescriptions'
          treeModel.update();

          this.petService.pet_prescriptions_filter = [];
          this.petService.pet_prescriptions_filter.push(...this.petService.pet_prescriptions);
          break;

      }

      $('#modalFilterHistory').modal('toggle');
      treeModel.expandAll();
      Swal.close();
    }, 150);
  }

  loadPrescriptionsData() {
    // Set the current pet number in the service before making the API call
    this.petService.current_pet_no = this.pet_no;

    // Clear prescription selection when loading new data
    this.selectedPrescription = null;

    console.log('Loading prescriptions data for pet_no:', this.pet_no);

    // Load prescriptions data by calling getHistoriesByPetId
    this.petService.getHistoriesByPetId(this.pet_no)
      .then(() => {
        console.log('Prescriptions data loaded:', this.petService.pet_prescriptions);
        console.log('Number of prescriptions:', this.petService.pet_prescriptions.length);
        console.log('Filtering state:', this.filtering_presc);
        console.log('Filtered prescriptions:', this.petService.pet_prescriptions_filter);
      })
      .catch((error) => {
        console.error('Error loading prescriptions data:', error);
      });
  }

  printPrescription() {

    // Check if a prescription is selected
    if (!this.selectedPrescription) {
      Swal.fire('No prescription selected', 'Please double-click on a prescription row to select it, then click Print', 'warning');
      return;
    }
    let clinicNo = '';

    if (localStorage.currentUser && localStorage.token) {
      const currentUser = JSON.parse(localStorage.currentUser);
      clinicNo = currentUser.clinic_no;
    }
    let $string = `admin` + "U*63r" + 'rptPrescription' + "R0d&3" + 'pdf' + "R3nd%" + '' + "Fr3n6" + `Estimate #${this.petService.pet_estimate.estimate_sequence} ${new Date().getTime()}` + "T1*73";
    let $result = encode_utf8($string);
    $result = encode_base64($result);

    let $strfilter = `&drug_note_sequence=${this.selectedPrescription.drug_note_sequence}&PetNo=${this.petService.current_pet_no}&ClinicNo=${clinicNo}`;
    console.log($strfilter);

    let url = `https://ssrs.itimpact.com/fpc_ssrs/default.aspx?token=${$result}${$strfilter}`;
    console.log(url);

    window.open(url, '_self', 'visible=none');


    // // Get current pet and client data
    // const currentPet = this.petService.pet_detail;
    // const currentClient = this.clientService.client;

    // // Create the print content
    // const printContent = this.generatePrescriptionReport(this.selectedPrescription, currentPet, currentClient);

    // // Open print window
    // const printWindow = window.open('', '_blank');
    // if (printWindow) {
    //   printWindow.document.write(printContent);
    //   printWindow.document.close();
    //   printWindow.focus();
    //   printWindow.print();
    //   printWindow.close();
    // }
  }

  printSuggestions() {

    let clinicNo = '';

    if (localStorage.currentUser && localStorage.token) {
      const currentUser = JSON.parse(localStorage.currentUser);
      clinicNo = currentUser.clinic_no;
    }
    let $string = `admin` + "U*63r" + 'rptSuggestions' + "R0d&3" + 'pdf' + "R3nd%" + '' + "Fr3n6" + `Suggestions Pet #${this.petService.current_pet_no} ${new Date().getTime()}` + "T1*73";
    let $result = encode_utf8($string);
    $result = encode_base64($result);

    let $strfilter = `&PetNo=${this.petService.current_pet_no}&ClinicNo=${clinicNo}`;
    console.log($strfilter);

    let url = `https://ssrs.itimpact.com/fpc_ssrs/default.aspx?token=${$result}${$strfilter}`;
    console.log(url);

    window.open(url, '_self', 'visible=none');


    // // Get current pet and client data
    // const currentPet = this.petService.pet_detail;
    // const currentClient = this.clientService.client;

    // // Create the print content
    // const printContent = this.generatePrescriptionReport(this.selectedPrescription, currentPet, currentClient);

    // // Open print window
    // const printWindow = window.open('', '_blank');
    // if (printWindow) {
    //   printWindow.document.write(printContent);
    //   printWindow.document.close();
    //   printWindow.focus();
    //   printWindow.print();
    //   printWindow.close();
    // }
  }

  private generatePrescriptionReport(prescription: PrescriptionsModel, pet: any, client: any): string {
    // Calculate pet age
    const calculateAge = (dob: string) => {
      if (!dob) return '';
      const birthDate = new Date(dob);
      const today = new Date();
      const ageInMs = today.getTime() - birthDate.getTime();
      const ageInYears = Math.floor(ageInMs / (1000 * 60 * 60 * 24 * 365.25));
      const ageInMonths = Math.floor((ageInMs % (1000 * 60 * 60 * 24 * 365.25)) / (1000 * 60 * 60 * 24 * 30.44));
      return `${ageInYears} Years ${ageInMonths} Months`;
    };

    const petAge = calculateAge(pet.dob);
    const prescriptionDate = prescription.drug_note_date || new Date().toLocaleDateString();

    // Get clinic information from client service
    const clinicName = this.clientService.clinic_details?.clinic_name || '';
    const clinicAddress = this.clientService.clinic_details?.clinic_address || '';
    const clinicCity = this.clientService.clinic_details?.city || '';
    const clinicState = this.clientService.clinic_details?.state || '';
    const clinicZip = this.clientService.clinic_details?.clinic_zip || '';
    const clinicPhone = this.clientService.clinic_details?.clinic_phone || '';

    const fullAddress = `${clinicAddress}, ${clinicCity}, ${clinicState} ${clinicZip}`;

    return `
      <!DOCTYPE html>
      <html>
      <title>Prescription Report</title>
      <head>
        <style>
          body {
            font-family: 'Courier New', monospace;
            font-size: 12px;
            line-height: 1.4;
            margin: 20px;
            background: white;
          }
          .header {
            text-align: left;
            margin-bottom: 20px;
            border-bottom: 1px solid #000;
            padding-bottom: 10px;
          }
          .facility-info {
            margin-bottom: 15px;
          }
          .section {
            margin-bottom: 15px;
          }
          .section-title {
            font-weight: bold;
            margin-bottom: 5px;
          }
          .info-row {
            margin-bottom: 3px;
          }
          .label {
            font-weight: bold;
            display: inline-block;
            min-width: 120px;
          }
          .value {
            display: inline-block;
          }
          .prescription-details {
            margin-top: 20px;
            border-top: 1px solid #000;
            padding-top: 10px;
          }
          @media print {
            body { margin: 0; }
          }
        </style>
      </head>
      <body>
        <br>
        <div class="header">
          <div class="facility-info">
            <div class="info-row">
              <span class="value">${clinicName}</span>
            </div>
            <div class="info-row">
              <span class="value">${fullAddress}</span>
            </div>
            <div class="info-row">
              <span class="value">${clinicPhone}</span>
            </div>
          </div>
        </div>

        <div class="section">
          <div class="section-title">Client Information:</div>
          <div class="info-row">
            <span class="label">First Name:</span>
            <span class="value">${client.first_name || ''}</span>
          </div>
          <div class="info-row">
            <span class="label">Last Name:</span>
            <span class="value">${client.last_name || ''}</span>
          </div>
          <div class="info-row">
            <span class="label">Address:</span>
            <span class="value">${client.address || ''}, ${client.city || ''}, ${client.state || ''} ${client.zip || ''}</span>
          </div>
          <div class="info-row">
            <span class="label">Phone:</span>
            <span class="value">${client.home_phone || ''}</span>
          </div>
        </div>

        <div class="section">
          <div class="section-title">Patient (Pet) Information:</div>
          <div class="info-row">
            <span class="label">Name:</span>
            <span class="value">${pet.pet_name || ''}</span>
          </div>
          <div class="info-row">
            <span class="label">Species:</span>
            <span class="value">${pet.specie_name || ''}</span>
          </div>
          <div class="info-row">
            <span class="label">Date of Birth:</span>
            <span class="value">${pet.dob ? new Date(pet.dob).toLocaleDateString() : ''} (estimated age: ${petAge || ''})</span>
          </div>
        </div>

        <div class="prescription-details">
          <div class="section-title">Prescription/Product Details:</div>
          <div class="info-row">
            <span class="label">Date of Record/Prescription:</span>
            <span class="value">${prescriptionDate}</span>
          </div>
          <div class="info-row">
            <span class="label">Product Name:</span>
            <span class="value">${prescription.product_name || ''}</span>
          </div>
          <div class="info-row">
            <span class="label">Count:</span>
            <span class="value">${prescription.units || ''} ${prescription.package || ''}</span>
          </div>
          <div class="info-row">
            <span class="label">Usage Directions:</span>
            <span class="value">${prescription.instructions || ''}</span>
          </div>
          <div class="info-row">
            <span class="label">Doctor:</span>
            <span class="value">${prescription.employee_initial || ''}</span>
          </div>
          <div class="info-row">
            <span class="label">Refills:</span>
            <span class="value">${prescription.refill_count || ''}</span>
          </div>
          <div class="info-row">
            <span class="label">Refill Expiry:</span>
            <span class="value">${prescription.refill_expire || ''}</span>
          </div>
        </div>
      </body>
      </html>
    `;
  }

  isDateValid(dateStr: string) {
    var timestamp = Date.parse(dateStr);
    return !isNaN(timestamp);
  }

  order(_order: number) {
    console.log('Order method called with order:', _order);
    this.petService.pet_histories = [];
    this.petService.pet_subhistories = [];
    this.petService.pet_suggestions = [];
    this.petService.pet_prescriptions = [];
    this.petService.histories_order = _order;
    this.petService.histories_page_number = 1;
    this.petService.getHistoriesByPetId(this.petService.current_pet_no)
      .then(() => {
        console.log('Order method - prescriptions reloaded:', this.petService.pet_prescriptions.length);
      });
  }

  presOrder(_order: number) {
    this.petService.prescription_order = _order;
  }

  // Handle modal close event
  onModalClose() {
    // Reset filter form when modal is closed
    this.code = '';
    this.category = '';
    this.subcategory = '';
    this.description = '';
    this.selectedTreeList = [];
  }



  nodes = [
    {
      name: 'Procedures',
      children: []
    }
  ];

  nodes1 = [
    {
      name: 'Codes',
      children: []
    }
  ];

  nodes2 = [
    {
      name: 'Categories',
      children: []
    }
  ];

  options: ITreeOptions = {
    useVirtualScroll: false,
    isExpandedField: 'expanded',
    animateExpand: true,
    useCheckbox: true,
    allowDrag: false,
    allowDrop: false,
    levelPadding: 20,
    scrollOnActivate: true,
    scrollContainer: document.documentElement
  };

  // Print modal methods
  openPrintHistoryModal() {
    // Reset form values
    this.printOptions = {
      printType: '',
      beginDate: '',
      endDate: '',
      printPrescriptionLog: false
    };

    // Open modal
    $('#modalPrintHistory').modal('show');
  }

  printHistory() {
    // Validate form
    if (!this.printOptions.printType || !this.printOptions.beginDate || !this.printOptions.endDate) {
      Swal.fire({
        title: 'Validation Error',
        text: 'Please fill in all required fields.',
        icon: 'error'
      });
      return;
    }

    // Validate date range
    const beginDate = new Date(this.printOptions.beginDate);
    const endDate = new Date(this.printOptions.endDate);

    if (beginDate > endDate) {
      Swal.fire({
        title: 'Date Error',
        text: 'Begin date cannot be later than end date.',
        icon: 'error'
      });
      return;
    }

    // Close modal
    $('#modalPrintHistory').modal('hide');

    // Show success message and implement print logic
    Swal.fire({
      title: 'Print Options Selected',
      html: `
        <strong>Print Type:</strong> ${this.printOptions.printType === 'historyOnly' ? 'Print History Only' : 'Print History with Notes'}<br>
        <strong>Date Range:</strong> ${this.printOptions.beginDate} to ${this.printOptions.endDate}<br>
        <strong>Print Prescription Log:</strong> ${this.printOptions.printPrescriptionLog ? 'Yes' : 'No'}
      `,
      icon: 'success',
      showCancelButton: true,
      confirmButtonText: 'Proceed with Print',
      cancelButtonText: 'Cancel'
    }).then((result) => {
      if (result.isConfirmed) {
        // Here you can implement the actual print logic
        console.log('Print options:', this.printOptions);

        let clinicNo = '';

        if (localStorage.currentUser && localStorage.token) {
          const currentUser = JSON.parse(localStorage.currentUser);
          clinicNo = currentUser.clinic_no;
        }

        let rptName = '';
        if (this.printOptions.printType === 'historyOnly') {
          rptName = 'rptHistory';
        } else {
          rptName = 'rptHistoryWithNotes';
        }


        let $string = `admin` + "U*63r" + rptName + "R0d&3" + 'pdf' + "R3nd%" + '' + "Fr3n6" + `History Pet #${this.petService.current_pet_no} ${new Date().getTime()}` + "T1*73";
        let $result = encode_utf8($string);
        $result = encode_base64($result);

        let $strfilter = `&StartDate=${this.printOptions.beginDate}&EndDate=${this.printOptions.endDate}&PetNo=${this.petService.current_pet_no}&ClinicNo=${clinicNo}&clinic_type=1&IncludePrescriptionLog=${this.printOptions.printPrescriptionLog}`;
        console.log($strfilter);

        let url = `https://ssrs.itimpact.com/fpc_ssrs/default.aspx?token=${$result}${$strfilter}`;
        console.log(url);

        window.open(url, '_self', 'visible=none');

        // Example: Call a service method to handle printing
        // this.petService.printHistory(this.printOptions);

        // Swal.fire({
        //   title: 'Printing...',
        //   text: 'The history report is being prepared for printing.',
        //   icon: 'info',
        //   timer: 2000,
        //   showConfirmButton: false
        // });
      }
    });
  }

  transferToPVL(petProcsModel: PetProcsModel[]) {
    this.ver('procedures');

    if (petProcsModel.length > 0) {
      this.procedureService.notify_FromEstModalFunction(petProcsModel);
    }
    else {
      this.procedureService.notify_InitProcTableModalFunction();
    }

  }


}
